import type { BrandingPalette } from '@gftg/shared';

export type { BrandingPalette, BrandingToken } from '@gftg/shared';

/**
 * Applies the event's palette by setting the custom properties theme.css reads. Tokens the
 * organizer left unset keep their theme.css value, so a partial media kit still renders a
 * coherent app (CNT-04).
 */
export function applyBranding(palette: BrandingPalette, target?: HTMLElement): void {
  const element = target ?? document.documentElement;

  for (const [token, value] of Object.entries(palette)) {
    if (value) {
      element.style.setProperty(`--gftg-${token}`, value);
    }
  }
}

/**
 * Applies the display and interface typefaces from the media kit, when the client supplied
 * them. Only the family is swapped: the size and weight scale belongs to the brand kit, not to
 * the database.
 */
export function applyBrandingFonts(
  fonts: { display?: string | null; ui?: string | null },
  target?: HTMLElement,
): void {
  const element = target ?? document.documentElement;

  if (fonts.display) {
    element.style.setProperty('--gftg-font-display', fonts.display);
  }
  if (fonts.ui) {
    element.style.setProperty('--gftg-font-ui', fonts.ui);
  }
}
